<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="颜色1">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.colors[0]" enableAlpha/>
    </t-form-item>
    <t-form-item label="颜色2">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.colors[1]" enableAlpha/>
    </t-form-item>
    <t-form-item label="样式">
      <t-select size="small" v-model="attribute.shape" placeholder="请选择">
        <t-option label="矩形" value="rect"/>
        <t-option label="圆角矩形" value="roundRect"/>
        <t-option label="圆形" value="round"/>
      </t-select>
    </t-form-item>
    <t-form-item label="波浪数量">
      <t-input-number size="small" v-model="attribute.waveNum" :min="1" :max="20" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="波浪高度">
      <t-input-number size="small" v-model="attribute.waveHeight" :min="1" :max="200" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="波浪透明度">
      <t-input-number size="small" v-model="attribute.waveOpacity" :min="0" :max="1" :step="0.1"/>
    </t-form-item>
    <t-form-item label="信息格式化">
      <t-textarea style="color: #fff" v-model="attribute.formatter"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-dataV-waterLevel-option",
  components: {CptData},
  props: { attribute: Object,cptDataForm:Object, }
}
</script>

<style scoped>

</style>
